module.exports = "/assets/data/7dfa0906db48abd78944a69523627240-E12.data.json";